'use client';

import Link from 'next/link';
import PropTypes from 'prop-types';
import { Card, CardActionArea, CardMedia, Container, Grid, Typography } from '@mui/material';
import { COLLECTIONS_PATH } from '@/consts/routes';
import CollectionSubNavLinks from './CollectionSubNavLinks';
import GalleryProseHtml from './GalleryProseHtml';

export default function SubCollectionDetailPage({ subCollection, subNavLinks }) {
  const { parentCollection } = subCollection;

  return (
    <Container maxWidth="xl" sx={{ py: 8.5 }}>
      {parentCollection ? (
        <Typography
          component={Link}
          href={`${COLLECTIONS_PATH}/${parentCollection.slug}`}
          sx={{
            display: 'inline-block',
            mb: 1,
            fontWeight: 600,
            fontSize: { xs: 14, md: 15 },
            color: 'text.primary',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          {parentCollection.name}
        </Typography>
      ) : null}

      <Typography variant="h4" sx={{ fontWeight: 600 }}>
        {subCollection.title}
      </Typography>

      <GalleryProseHtml html={subCollection.description} sx={{ mt: 2, maxWidth: 900 }} />

      {parentCollection ? (
        <CollectionSubNavLinks collectionName={parentCollection.name} links={subNavLinks} />
      ) : null}

      {Array.isArray(subCollection.projects) && subCollection.projects.length > 0 ? (
        <Grid container spacing={3} sx={{ mt: 4 }}>
          {subCollection.projects.map(project => {
            const image = project.thumbnail ? (
              <CardMedia
                component="img"
                src={project.thumbnail}
                alt=""
                sx={{ aspectRatio: '16 / 9', objectFit: 'cover', display: 'block' }}
              />
            ) : null;

            return (
              <Grid key={project.portfolioSlug} item xs={12} md={6}>
                <Card sx={{ overflow: 'hidden' }}>
                  {project.href ? (
                    <CardActionArea component={Link} href={project.href} aria-label="View project">
                      {image}
                    </CardActionArea>
                  ) : (
                    image
                  )}
                </Card>
              </Grid>
            );
          })}
        </Grid>
      ) : null}
    </Container>
  );
}

SubCollectionDetailPage.propTypes = {
  subCollection: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    parentCollection: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
    projects: PropTypes.arrayOf(
      PropTypes.shape({
        href: PropTypes.string,
        thumbnail: PropTypes.string,
        portfolioSlug: PropTypes.string.isRequired,
      }),
    ),
  }).isRequired,
  subNavLinks: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    }),
  ),
};
